import React, { Component } from 'react';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import is from 'is_js';
import { List } from 'immutable';
import {
  connect,
  ApiResponseHelper,
  Config,
  Icon,
  PrivilegeChecker,
  testClass,
  moment,
} from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import PropTypes from 'prop-types';
import styles from './style.postcss';

import { actions as onlineHomeworkActions } from 'data/OnlineHomework';
import { actions as totalPointActions } from 'data/OnlineHomework/TotalPoint';
import { actions as hfUsageActions } from 'data/OnlineHomework/HFUsage';
import { actions as GroupMembers } from 'data/GroupMembers';
import { actions as Group } from 'containers/Group';
import { actions as Session } from 'data/SessionPlans';
import { getUnitNumberById, getUnitList } from 'data/Units/accessors';
import tableStyles from '../style.postcss';
import CourseViewTable from 'components/CourseViewTable';
import {
  EXTRA_COLUMNS,
  renderHFUsageHeader,
  renderHFUsageSubHeader,
} from './hfUsage';

const NOT_APPLICABLE = 'N/A';
const TOTAL_POINTS = 'total-points';
const DATE_FORMAT = 'YYYY-MM-DD';
const DEFAULT_CELL = '';

export class StudentApp extends Component {
  constructor(props) {
    super(props);
    this._setUpData(props);
  }

  componentWillMount() {
    const {
      onlineHomeworks,
      groupId,
      isTBCourseTypeGroup,
      isHFCourseTypeGroup,
      hasContentPath,
    } = this.props;
    if (ApiResponseHelper.shouldFetch(onlineHomeworks)) {
      this.props.fetchOnlineHomework(groupId);
    }
    if (isTBCourseTypeGroup) {
      this.props.fetchStudentTotalPoints(groupId);
    }

    if (isHFCourseTypeGroup && ! hasContentPath) {
      this.props.fetchOnlineHomeworkHFUsage(groupId);
    }
  }

  componentWillReceiveProps(props) {
    this._setUpData(props);
  }

  _setUpData(props) {
    const { sessions, onlineHomeworks } = props;
    if (! sessions || ! sessions.data || ! onlineHomeworks || ! onlineHomeworks.data) {
      this._sessions = [];
      return;
    }

    this._setSessions(props);
    this._setHighlightedColumnsNo(props);
  }

  _setSessions({ sessions, onlineHomeworks }) {
    this._sessions = onlineHomeworks.data
      .filter((homeworkBySession) =>
        sessions.data.some((session) => session.id === homeworkBySession.sessionId)
      )
      .map((homeworkBySession) =>
        sessions.data
          .find((session) => homeworkBySession.sessionId === session.id)
          .set('lessonNumber', homeworkBySession.lessonNumber)
          .set('unitOrderingSequence', homeworkBySession.unitOrderingSequence)
      )
      .sort(this._sortSessions);
  }

  _sortSessions(a, b) {
    if (a.index !== b.index) return a.index - b.index;
    if (a.unitOrderingSequence !== b.unitOrderingSequence) {
      return a.unitOrderingSequence - b.unitOrderingSequence;
    }
    return a.lessonNumber - b.lessonNumber;
  }

  _setHighlightedColumnsNo({ defaultSessionId, hasTotalPoints }) {
    const firstIndexOfHighlightedColumn =
      this._sessions.findIndex((session) => session.id === defaultSessionId) * 2;
    const highlightedColumnSize = 
      this._sessions.filter((session) => session.id === defaultSessionId).size * 2;
    this._highlightedColumns = [];
    for (let i = 0; i < highlightedColumnSize; i++) {
      this._highlightedColumns[i] = hasTotalPoints ?
        firstIndexOfHighlightedColumn + i + 1 :
        firstIndexOfHighlightedColumn + i;
    }
  }

  _renderScore(score, category) {
    if (is.not.undefined(score) && is.existy(score[category])) {
      return `${score[category]}%`;
    }
    return NOT_APPLICABLE;
  }

  _renderSessionNumbers() {
    const {
      groupId,
      defaultSessionId,
      hasTotalPoints,
      isHFCourseTypeGroup,
      isHFV4CourseTypeGroup,
      isFRV2CourseTypeGroup,
      hasContentPath,
      games,
      onlineHomeworks,
    } = this.props;

    const getClassName = (className) =>
      classnames(tableStyles.Homework_innerTable_Th, className, testClass('session-lesson-column'));
    const classes = (session) =>
      getClassName({
        [tableStyles.Homework_innerTable_active]: session.id === defaultSessionId,
      });

    const cellItems = [];
    cellItems.push(
      this._sessions.map((session) => {
        const sessionHomework = onlineHomeworks.data
          .find(
            (homeworkBySession) =>
              homeworkBySession.sessionId === session.id &&
              homeworkBySession.lessonNumber === session.lessonNumber
          );
        const completedResults = sessionHomework.studentOnlineHomeworkResults.filter(
          (r) => !! r.completion
        );
        let homeworkViewLink;
        if (isFRV2CourseTypeGroup) {
          const fr2ViewerBaseUrl = Config.get('fr2OnlineHomeworkViewerUrl');

          if (completedResults.size > 0) {
            const studentIds = completedResults.map((r) => r.studentId).join(',');
            homeworkViewLink = `${fr2ViewerBaseUrl}/?entrance=hw&students=${studentIds}&contentPath=${sessionHomework.onlineHomeworkKey}`;
          } else {
            homeworkViewLink = `${fr2ViewerBaseUrl}/?entrance=hw&contentPath=${sessionHomework.onlineHomeworkKey}`;
          }
        } else if (isHFV4CourseTypeGroup) {
          const hf4ViewerBaseUrl = Config.get('hf4OnlineHomeworkViewerUrl');
          homeworkViewLink = `${hf4ViewerBaseUrl}/?type=hw&groupId=${groupId}&unit=${session.unitOrderingSequence}&lesson=${session.lessonNumber}`;
        }
        return <CourseViewTable.Cell className={classes(session)}
            key={`${session.id}-${session.unitOrderingSequence}-${session.lessonNumber}`}
            colSpan={2}
            small>
          <span>
            {`S${session.index}, U${session.unitOrderingSequence}, L${session.lessonNumber}`}
          </span>
          {
            homeworkViewLink &&
            <Link className={styles.LessonHomeworkViewerLink}
                to={homeworkViewLink}
                draggable={false}
                tabIndex="-1"
                target="_blank">
              Viewer <Icon id="arrow-right" className={styles.LessonHomeworkViewerLink_icon} />
            </Link>
          }
        </CourseViewTable.Cell>;
      })
    );
    if (hasTotalPoints) {
      cellItems.unshift(<CourseViewTable.Cell />);
    }

    if (isHFCourseTypeGroup && ! hasContentPath) {
      cellItems.push(renderHFUsageHeader(games));
    }

    return cellItems;
  }

  _renderDates() {
    const { defaultSessionId, timeZone, hasTotalPoints } = this.props;
    const getClassName = (className) => classnames(tableStyles.Homework_innerTable_Th, className);
    const classes = (session) =>
      getClassName({
        [tableStyles.Homework_innerTable_active]: session.id === defaultSessionId,
      });

    const cellItems = [];
    cellItems.push(
      this._sessions.map((session) => (
        <CourseViewTable.Cell className={classes}
            key={`${session.id}-${session.unitOrderingSequence}-${session.lessonNumber}`}
            colSpan={2}
            small>
          {session.period.start
            .clone()
            .tz(timeZone)
            .format('ddd D MMM')}
        </CourseViewTable.Cell>
      ))
    );
    if (hasTotalPoints) {
      cellItems.unshift(<CourseViewTable.Cell />);
    }
    return cellItems;
  }

  _renderScoreCategoryRow() {
    const { hasTotalPoints, isHFCourseTypeGroup, hasContentPath, games } = this.props;

    const cellItems = [];
    cellItems.push(
      this._sessions.map((session) => [
        <CourseViewTable.Cell columnId={{ session, column: 'completion' }} small>
          Completion
        </CourseViewTable.Cell>,
        <CourseViewTable.Cell columnId={{ session, column: 'accuracy' }} small>
          1st Time Accuracy
        </CourseViewTable.Cell>,
      ])
    );
    if (hasTotalPoints) {
      cellItems.unshift(
        <CourseViewTable.Cell columnId={{ column: TOTAL_POINTS }} small>
          Total Points
        </CourseViewTable.Cell>
      );
    }
    if (isHFCourseTypeGroup && ! hasContentPath) {
      cellItems.push(renderHFUsageSubHeader(games));
    }
    return cellItems;
  }

  _renderHFUsageColumn(column, studetnId, usageIndex) {
    const { onlineHomeworkHFUsage } = this.props;
    const HFUsage = onlineHomeworkHFUsage && onlineHomeworkHFUsage.get(studetnId);
    if (! HFUsage) return DEFAULT_CELL;
    const usage = HFUsage.onlineUsages && HFUsage.onlineUsages[usageIndex];
    switch (column) {
      case EXTRA_COLUMNS.ACTIVITIES_COMPLETED:
      case EXTRA_COLUMNS.GAME_COMPLETED:
        return this._renderUsage(usage);
      case EXTRA_COLUMNS.LAST_ACTIVITIES_DATE:
      case EXTRA_COLUMNS.GAME_COMPLETED_DATE:
        return this._renderDate(usage);
      case EXTRA_COLUMNS.DIAMONDS:
        return `${HFUsage.gainedDiamonds}/${HFUsage.totalDiamonds}`;
      default:
        return DEFAULT_CELL;
    }
  }

  _renderUsage(usage = {}) {
    const completed = usage.completedCoreActivities || DEFAULT_CELL;
    const total = usage.allCoreActivities || DEFAULT_CELL;
    if (completed || total) {
      return `${completed}/${total}`;
    }
    return DEFAULT_CELL;
  }

  _renderDate(usage = {}) {
    const dataString = usage.completedOn;
    if (dataString && this._getDateFomat(dataString)) {
      return <div style={{ whiteSpace: 'nowrap' }}>
        {this._getDateFomat(dataString)}
      </div>;
    }
    return DEFAULT_CELL;
  }

  _getDateFomat(dataString) {
    let _moment = moment.utc(dataString).clone().tz(this.props.timeZone);
    if (! _moment) {
      _moment = moment.utc(dataString);
    }
    return _moment.format(DATE_FORMAT);
  }

  render() {
    const { members, onlineHomeworks, studentTotalPoints } = this.props;

    if (! onlineHomeworks || ! onlineHomeworks.data) {
      return null;
    }

    return (
      <div>
        <CourseViewTable students={members} highlightedColumns={this._highlightedColumns}>
          <CourseViewTable.Header>
            <CourseViewTable.Row>{this._renderSessionNumbers()}</CourseViewTable.Row>
            <CourseViewTable.Row>{this._renderDates()}</CourseViewTable.Row>
            <CourseViewTable.Row>{this._renderScoreCategoryRow()}</CourseViewTable.Row>
          </CourseViewTable.Header>
          <CourseViewTable.Body>
            {(member, { session, column, usageIndex }) => {
              const studentId = member.studentGeneralInfo.id;
              if (column === TOTAL_POINTS) {
                const studentTotalPoint =
                  studentTotalPoints &&
                  studentTotalPoints.find((totalPoint) => totalPoint.studentId === studentId);
                const totalPoint = studentTotalPoint && studentTotalPoint.totalPoint;
                return totalPoint || '-';
              }

              if (Object.values(EXTRA_COLUMNS).includes(column)) {
                return this._renderHFUsageColumn(column, studentId, usageIndex);
              }

              const onlineHomeworkCell = onlineHomeworks.data
                .find(
                  (homeworkBySession) =>
                    homeworkBySession.sessionId === session.id &&
                    homeworkBySession.lessonNumber === session.lessonNumber
                )
                .studentOnlineHomeworkResults.find(
                  (homeworkByStudent) => homeworkByStudent.studentId === studentId
                );

              if (column === 'accuracy') {
                return this._renderScore(onlineHomeworkCell, 'accuracy');
              }

              return this._renderScore(onlineHomeworkCell, 'completion');
            }}
          </CourseViewTable.Body>
        </CourseViewTable>
      </div>
    );
  }
}

StudentApp.propTypes = {
  groupId: PropTypes.string.isRequired,
  timeZone: PropTypes.string,
  defaultSessionId: PropTypes.string,
  courseTypeCode: PropTypes.string,
  fetchOnlineHomework: PropTypes.func,
  fetchOnlineHomeworkHFUsage: PropTypes.func,
  fetchStudentTotalPoints: PropTypes.func.isRequired,
  members: PropTypes.object,
  sessions: PropTypes.object,
  onlineHomeworks: PropTypes.object,
  state: PropTypes.object.isRequired,
  isSessionHeadingClickable: PropTypes.bool.isRequired,
  studentTotalPoints: PropTypes.object,
  isTBCourseTypeGroup: PropTypes.bool.isRequired,
  isHFCourseTypeGroup: PropTypes.bool.isRequired,
  isHFV4CourseTypeGroup: PropTypes.bool.isRequired,
  isFRV2CourseTypeGroup: PropTypes.bool.isRequired,
  hasContentPath: PropTypes.bool.isRequired,
  onlineHomeworkHFUsage: PropTypes.object,
  hasTotalPoints: PropTypes.bool.isRequired,
  games: PropTypes.array,
};

export function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const group = Group.getGroup(state, groupId);
  const { timeZone } = Group.getCentre(state, groupId);
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const sessions = getSessions(group, state);
  const units = getUnitList(state, groupId);
  let onlineHomeworks = state
    .get('rootReducer')
    .get('onlineHomework')
    .get(groupId);
  const onlineHomeworksData =
    onlineHomeworks &&
    onlineHomeworks.data &&
    onlineHomeworks.data.map((onlineHomework) =>
      onlineHomework.set('unitOrderingSequence', getUnitNumberById(units, onlineHomework.unitId))
    );
  onlineHomeworks = onlineHomeworks && onlineHomeworks.set('data', onlineHomeworksData);
  const defaultSession = Session.getDefaultSession(state, groupId);
  const isSessionHeadingClickable = PrivilegeChecker.hasPrivilege(
    state,
    Privileges.Homework.ViewAssignments
  );
  const studentTotalPoints = state
    .get('rootReducer')
    .get('studentTotalPoints')
    .get(groupId);
  const isTBCourseTypeGroup = Group.isTBCourseTypeGroup(state, groupId);
  const isHFCourseTypeGroup = Group.isHFCourseTypeGroup(state, groupId);
  const isHFV4CourseTypeGroup = Group.isHFV4CourseTypeGroup(state, groupId);
  const isFRV2CourseTypeGroup = Group.isFRV2CourseTypeGroup(state, groupId);

  const hasContentPath = Group.hasContentPath(state, groupId);

  const onlineHomeworkHFUsage = state
    .get('rootReducer')
    .get('onlineHomeworkHFUsage')
    .get(groupId);

  const hasTotalPoints = studentTotalPoints && studentTotalPoints.size > 0;
  const games = new Array(3);
  for (let i = 0; i < games.length; i++) {
    games[i] = {
      index: i + 1,
    };
  }
  return {
    groupId,
    courseTypeCode: group.courseTypeCode,
    timeZone,
    defaultSessionId: defaultSession.id,
    members,
    sessions,
    onlineHomeworks,
    state,
    isSessionHeadingClickable,
    studentTotalPoints,
    isTBCourseTypeGroup,
    isHFCourseTypeGroup,
    isHFV4CourseTypeGroup,
    isFRV2CourseTypeGroup,
    hasContentPath,
    hasTotalPoints,
    onlineHomeworkHFUsage,
    games,
  };
}

function getSessions(group, state) {
  if (is.undefined(group.sessionPlans.data)) {
    return group.sessionPlans;
  }

  const getSession = (sessionId) =>
    state
      .get('rootReducer')
      .get('sessionPlans')
      .get(sessionId);
  return group.sessionPlans
    .update('data', (data) => new List(data))
    .update('data', (data) => data.map(getSession));
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    bindActionCreators(onlineHomeworkActions, dispatch),
    bindActionCreators(totalPointActions, dispatch),
    bindActionCreators(hfUsageActions, dispatch)
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentApp);



// WEBPACK FOOTER //
// ./containers/Group/Homework/StudentApp/component.jsx